// extracted by mini-css-extract-plugin
export default {"adserve":"Adserve_adserve__JrXQe","overlay":"Adserve_overlay__59u8h","text":"Adserve_text__1BodH","btn":"Adserve_btn__qcHJ7"};